{
  "_meta": {
    "status": "DRAFT",
    "warning": "AI-generated best-effort translations. MUST be reviewed by a Polish native speaker familiar with insurance/veterinary terminology before production use. Sent verbatim to pet parents."
  },
  "common": {
    "to": "do",
    "from": "od"
  },
  "missing_info": {
    "clinical_history": "Czym jest historia kliniczna?\n\nHistoria kliniczna zawiera wszystkie wizyty u weterynarza, zarówno z powodu choroby lub wypadku, jak i rutynowe wizyty kontrolne czy szczepienia, wraz z datą wizyty i odpowiednimi notatkami weterynaryjnymi. Każda strona tego dokumentu musi być ponumerowana, a na ostatniej stronie potrzebny jest podpis i pieczęć kliniki. Należy również dołączyć zaświadczenie, że wizyty zawarte w historii to jedyne razy, gdy Twój pupil był w tej klinice.\n\nJak uzyskać historię kliniczną?\n\nTo proste! Twój weterynarz może udostępnić Ci historię kliniczną — wystarczy o nią poprosić. Jeśli odwiedzałeś więcej niż jedną klinikę, musisz poprosić o nią w każdej z nich. Jeśli byłeś tylko w jednej klinice w celu szczepienia, również potrzebujemy historii uwzględniającej te wizyty.",
    "vet_report": "Raport weterynaryjny\n\nRaport to dokument zawierający szczegóły wizyty, której dotyczy wniosek o zwrot. Powinien zawierać następujące informacje:\n    • Powód wizyty. Na przykład: „mój pies ma ból w łapie.”\n    • Występujące objawy. Na przykład: „ból przy dotyku, kulawizna, guzek na łapie...”\n    • Data pojawienia się objawów.\n    • Wykonane badania diagnostyczne. Na przykład: prześwietlenia, badanie fizykalne...\n    • Diagnoza. Na przykład: „uraz tylnej kończyny w wyniku stłuczenia.”\n    • Leczenie. Na przykład: „odpoczynek, krem przeciwzapalny, leki...”\n    • Data planowanej kontroli.",
    "invoice": "Faktura\n\nAby faktura była ważna, musi zawierać następujące informacje:\n    • Datę wystawienia faktury\n    • Numer NIP kliniki weterynaryjnej lub apteki\n    • Numer faktury\n    • Musi pojawić się słowo „faktura” — nie akceptujemy paragonów, kwitów dostawy ani kosztorysów.\n    • Kwota rozbita według zabiegów lub leków zaleconych przez weterynarza\n\nMożliwe, że wysłałeś poprawną fakturę, ale zdjęcie jest rozmazane, niskiej rozdzielczości lub coś uniemożliwia nam wyraźne zobaczenie danych. Wyślij nam zdjęcie ponownie, tak aby było czytelne.",
    "health": {
      "templates": [
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "One single document",
              "value": "Wyślij nam fakturę jako jeden dokument, najlepiej w formacie PDF. W postaci, w jakiej została wysłana, nie możemy poprawnie odczytać kolejności jej zawartości. Jeśli lekarz weterynarii wręczył Ci wydrukowaną fakturę i musisz zrobić jej zdjęcie, upewnij się, że cała mieści się na jednym zdjęciu.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Invoice complete",
              "value": "Potrzebujemy całej faktury. Pobierz fakturę w formacie PDF i wyślij nam ten dokument w sekcji dotyczącej faktury. Nie możemy zaakceptować faktur w postaci wielu zrzutów ekranu."
            },
            {
              "label": "Unreadable",
              "value": "Faktura, którą nam wysyłasz, jest nieczytelna lub ucięta. Wyślij kompletną fakturę formacie PDF.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Duplicated same invoice",
              "value": "Powtórzony numer faktury: wysłałeś już wcześniej fakturę o tym samym numerze.\nKażda faktura musi mieć unikalny numer; nie mogą istnieć dwie faktury tego samego wystawcy i z tego samego roku z tym samym numerem.\nUdaj się do swojej kliniki, aby wystawiła nową, ważną fakturę.\nPrześlij nam nową fakturę, upewniając się, że jest podpisana i opieczętowana przez klinikę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Duplicated other invoice",
              "value": "Powtórzony numer faktury: otrzymaliśmy już fakturę o tym samym numerze, ale dotyczącą innego zwierzaka.\nKażda faktura musi mieć unikalny numer; nie mogą istnieć dwie faktury tego samego wystawcy i z tego samego roku z tym samym numerem.\nUdaj się do swojej kliniki, aby wystawiła nową, ważną fakturę.\nPrześlij nam nową fakturę, upewniając się, że jest podpisana i opieczętowana przez klinikę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "Paragon zasłania fakturę i nie możemy odczytać jej treści.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Otrzymaliśmy fakturę tej kliniki o tym samym numerze, ale dotyczącą innego zwierzaka, więc nie jest ona ważna. Faktury muszą mieć unikalny numer — nie mogą istnieć dwie faktury tego samego wystawcy i z tego samego roku o tym samym numerze. Udaj się do kliniki i poproś o wystawienie ważnej faktury.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "More than one pet",
              "value": "Faktura, którą wysyłasz, obejmuje wydatki na kilka zwierząt. Prześlij osobną fakturę dla każdego ubezpieczonego zwierzaka.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Missing invoice",
              "value": "Potrzebujemy faktury za wykonane usługi. Pamiętaj, że na fakturze musi pojawić się numer NIP kliniki, numer faktury oraz data poniesienia wydatku.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Wrong pet",
              "value": "Faktura, którą nam wysyłasz, nie dotyczy ubezpieczonego zwierzaka.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Invoice not paid",
              "value": "Faktura nie została opłacona lub opłaciłeś tylko jej część. Akceptujemy wyłącznie faktury opłacone w całości.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Not an invoice",
              "value": "Dokument, który nam przesyłasz, nie jest fakturą. Nie martw się — aby ją otrzymać, wróć do lecznicy lub apteki i poproś o wystawienie faktury. Dokument musi zawierać: numer NIP kliniki, numer faktury oraz datę poniesienia wydatku. Zgodnie z warunkami polisy możemy akceptować tylko faktury. Pamiętaj, że paragony, kosztorysy, faktury proforma, faktury uproszczone lub faktury z numerem 0 nie są ważne.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Invoice number",
              "value": "Na fakturze, którą nam wysyłasz, brakuje numeru faktury.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "CIF",
              "value": "Dołączony dokument nie jest fakturą — poproś lekarza weterynarii o wystawienie faktury z numerem NIP kliniki.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Upfront payment",
              "value": "Faktura, którą nam wysłałeś, pokazuje, że wcześniej dokonałeś już częściowej płatności. Aby móc rozliczyć zwrot, potrzebujemy również faktury za tę pierwszą płatność.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Otrzymaliśmy Twój wniosek o zwrot kosztów, ale nie możemy zaakceptować zrzutów ekranu ani zdjęć ekranów dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF i załącz je przez aplikację."
            },
            {
              "label": "Signed and stamped",
              "value": "Potrzebujemy faktury podpisanej i opieczętowanej przez Twojego weterynarza.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Potrzebujemy historii weterynaryjnej Twojego zwierzaka od momentu, gdy mieszka z Tobą. Poproś o nią we wszystkich klinikach, w których był leczony. Musi zawierać:\n - Wszystkie wizyty u lekarza weterynarii: zarówno szczepienia, wizyty kontrolne, jak i z powodu choroby lub wypadku.\n - Datę każdej wizyty oraz obserwacje lekarza weterynarii.\n - Potwierdzenie, że jest kompletna: lekarz weterynarii powinien napisać np. „Brak innych zarejestrowanych wizyt w tej klinice”.\n - Podpisana i opieczętowana przez klinikę.\n - Jedna historia z każdej kliniki: jeśli odwiedziłeś więcej niż jedną klinikę, potrzebujemy historii z każdej z nich, nawet jeśli były to tylko wizyty na szczepienia.\n - Nie akceptujemy luźnych kartek ani niekompletnych dokumentów."
            },
            {
              "label": "Loose sheets",
              "value": "Potrzebujemy historii klinicznej w postaci jednego dokumentu. Niestety nie akceptujemy luźnych i nieuporządkowanych kartek."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Czego brakuje?",
                "options": [
                  {
                    "label": "Condition",
                    "value": "W historii brakuje wizyty związanej z chorobą {{condicion;STRING;true}} wymienioną w raporcie weterynaryjnym."
                  },
                  {
                    "label": "Clinic data",
                    "value": "W historii brakuje części lub wszystkich danych kliniki. Powinna pojawić się nazwa kliniki, jej NIP i/lub adres."
                  },
                  {
                    "label": "Pet details",
                    "value": "W historii brakuje części lub wszystkich danych zwierzaka: imienia, rasy i/lub numeru chipa."
                  },
                  {
                    "label": "Visit dates",
                    "value": "W historii brakuje następujących dat: {{fechas;DATE_RANGE;true}}"
                  },
                  {
                    "label": "Clinical notes",
                    "value": "Historia nie zawiera wszystkich obserwacji lekarza weterynarii dotyczących poszczególnych wizyt."
                  },
                  {
                    "label": "One or more clinics",
                    "value": "Brakuje wizyt z jednej lub kilku klinik: {{nombre_clínica;STRING;true}}."
                  }
                ]
              }
            },
            {
              "label": "Not a clinical history",
              "value": "Dokument, który nam wysyłasz, nie jest historią kliniczną. Poproś o nią we wszystkich klinikach, w których zwierzak był leczony. Musi zawierać:\n - Wszystkie wizyty u lekarza weterynarii: zarówno szczepienia, wizyty kontrolne, jak i z powodu choroby lub wypadku.\n - Datę każdej wizyty oraz obserwacje lekarza weterynarii.\n - Potwierdzenie, że jest kompletna: lekarz weterynarii powinien napisać np. „Brak innych zarejestrowanych wizyt w tej klinice”.\n - Podpisana i opieczętowana przez klinikę.\n - Jedna historia z każdej kliniki: jeśli odwiedziłeś więcej niż jedną klinikę, potrzebujemy historii z każdej z nich, nawet jeśli była to tylko wizyta na szczepienia.\n - Nie akceptujemy luźnych kartek ani niekompletnych dokumentów."
            },
            {
              "label": "Repeated attempts",
              "value": "Jak już wcześniej wskazywaliśmy, bez historii klinicznej Twojego zwierzaka nie możemy rozpatrzyć Twojego wniosku. Poproś o nią we wszystkich klinikach, w których był leczony. Musi zawierać:\n - Wszystkie wizyty u lekarza weterynarii: zarówno szczepienia, wizyty kontrolne, jak i z powodu choroby lub wypadku.\n - Datę każdej wizyty oraz obserwacje lekarza weterynarii.\n - Potwierdzenie, że jest kompletna: lekarz weterynarii powinien napisać np. „Brak innych zarejestrowanych wizyt w tej klinice”.\n - Podpisana i opieczętowana przez klinikę.\n - Jedna historia z każdej kliniki: jeśli odwiedziłeś więcej niż jedną klinikę, potrzebujemy historii z każdej z nich, nawet jeśli była to tylko wizyta na szczepienia.\n - Nie akceptujemy luźnych kartek ani niekompletnych dokumentów."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline Explanation",
              "value": {
                "group": "Explanation",
                "options": [
                  {
                    "label": "All",
                    "value": "Poproś lekarza weterynarii, aby dołączył do raportu lub jako załącznik do faktury wyjaśnienie, jakiemu leczeniu odpowiada każda pozycja na fakturze, ponieważ niektóre z nich nie są jednoznaczne. Powinno zawierać nazwę usługi lub leku i jego cenę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "One or more costlines",
                    "value": "Poproś lekarza weterynarii, aby dołączył do raportu lub jako załącznik do faktury wyjaśnienie, jakiemu leczeniu odpowiadają następujące pozycje faktury: {{línea_de_coste;STRING;true}}. Powinno zawierać nazwę usługi lub leku i jego cenę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Sessions",
              "value": "Potrzebujemy raportu zawierającego wszystkie wykonane sesje wraz z ich datami. Prześlij ten raport po zakończeniu leczenia, ponieważ nie możemy zwracać kosztów za sesje, które jeszcze się nie odbyły.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Changes",
              "value": "Raport weterynaryjny jest oficjalnym dokumentem urzędowym, dlatego nie możemy akceptować wprowadzonych w nim zmian. Potrzebujemy, aby Twój lekarz weterynarii wystawił nowy, opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, uzasadniający wprowadzoną zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "One document",
              "value": "Wyślij nam raport jako jeden dokument, najlepiej w formacie PDF. W postaci, w jakiej został wysłany, nie możemy poprawnie odczytać kolejności zawartości. Jeśli lekarz weterynarii wręczył Ci wydrukowany raport i musisz zrobić zdjęcie, upewnij się, że każda strona jest na osobnym, czytelnym zdjęciu w prawidłowej kolejności.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Missing vet report",
              "value": {
                "group": "Czego brakuje?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Brakuje raportu weterynaryjnego z następujących klinik: {{clinica;STRING;true}}.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Complete Vet report",
                    "value": "Potrzebujemy raportu weterynaryjnego. Musi to być dokument sporządzony przez lekarza weterynarii opisujący wizytę, której dotyczy wniosek o zwrot kosztów. Raport musi zawierać:\nPowód wizyty: np. „Mojego psa boli łapa.”\nZaobserwowane objawy: np. „Ból przy dotyku, kulawizna, guzek na łapie.”\nData pojawienia się objawów.\nWykonane badania: np. „Prześwietlenia, badanie kliniczne.”\nDiagnoza: np. „Uraz tylnej kończyny w wyniku stłuczenia.”\nZalecone leczenie: np. „Odpoczynek, leki.”\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Date",
                    "value": "Brakuje raportu weterynaryjnego z następujących dat: {{fecha;DATE_RANGE;true}}.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Date of symptoms",
              "value": {
                "group": "Kto powinien podać datę pojawienia się objawów?",
                "options": [
                  {
                    "label": "Petparent",
                    "value": "Potrzebujemy, abyś podał datę pojawienia się objawów.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF.",
                    "type": "DATE"
                  },
                  {
                    "label": "Vet",
                    "value": "W raporcie, który nam wysyłasz, nie ma daty pojawienia się objawów. Poproś lekarza weterynarii, aby ją dodał.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Czego brakuje?",
                "options": [
                  {
                    "label": "Costline explanation",
                    "value": "Raport weterynaryjny nie wspomina niektórych pozycji widocznych na fakturze. Na przykład, jeśli faktura obejmuje leki, a raport tego nie odnotowuje, potrzebujemy, aby lekarz weterynarii zaktualizował raport, uwzględniając wszystkie wykonane zabiegi.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Clinic data",
                    "value": "W raporcie brakuje części lub wszystkich danych kliniki: nazwy, NIP i adresu.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Pet details",
                    "value": "W raporcie brakuje części lub wszystkich danych zwierzaka: imienia, rasy i/lub numeru chipa.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Diagnosis",
                    "value": "W raporcie brakuje diagnozy Twojego zwierzaka.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Date of visit",
                    "value": "W raporcie brakuje daty wizyty u lekarza weterynarii.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Pages",
                    "value": "W raporcie, który nam wysłałeś, brakuje niektórych stron — jest niekompletny.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Diagnostics tests",
                    "value": "W raporcie brakuje wyników badań diagnostycznych (takich jak prześwietlenia, analizy itp.) wykonanych u Twojego zwierzaka.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Symptoms/reason for visit",
                    "value": "W raporcie brakuje powodu, dla którego odwiedziłeś lekarza weterynarii — czyli jasnego opisu objawów u Twojego zwierzaka.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Treatment",
                    "value": "W raporcie brakuje leczenia przepisanego Twojemu zwierzakowi.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Inconsistency between documents",
              "value": "Wykryliśmy następujące niezgodności w dokumentach, które nam wysyłasz: {{inconsistency;STRING;true}}. Potrzebujemy wyjaśnienia od Twojego lekarza weterynarii w postaci raportu.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Previous related reports",
              "value": "Potrzebujemy raportów z wcześniejszych wizyt związanych z tą chorobą. Powinny zawierać objawy, datę ich wystąpienia, wykonane badania, zalecone leczenie i przebieg choroby. Jeśli to dla Ciebie wygodniejsze, możesz nam przesłać pełną historię kliniczną.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Previous visits",
              "value": "Potrzebujemy, abyś wysłał wcześniejsze raporty związane z tą wizytą.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Poproś lekarza weterynarii, aby w raporcie lub załączniku do faktury wyszczególnił osobno każdą wykonaną usługę lub zabieg wraz z jego ceną.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "Raport, który nam wysyłasz, nie odpowiada fakturze. Upewnij się, że raport ma tę samą datę co faktura i zawiera pozycje, które są na niej rozliczane.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Unreadable",
              "value": "Raport weterynaryjny, który nam wysyłasz, jest nieczytelny lub ucięty. Wyślij nam kompletny raport w formacie PDF.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Not a vet report",
              "value": "Dokument, który nam wysłałeś, nie jest raportem weterynaryjnym. Musi to być dokument sporządzony przez lekarza weterynarii, opisujący wizytę, której dotyczy wniosek o zwrot kosztów. Raport powinien zawierać:\n - Powód wizyty: np. „Mojego psa boli łapa.”\n - Zaobserwowane objawy: np. „Ból przy dotyku, kulawizna, guzek na łapie.”\n - Data pojawienia się objawów.\n - Wykonane badania: np. „Prześwietlenia, badanie kliniczne.”\n - Diagnoza: np. „Uraz tylnej kończyny w wyniku stłuczenia.”\n - Zalecone leczenie: np. „Odpoczynek, leki.”.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Chronic condition",
              "value": "W przypadku zwrotów za leki na choroby przewlekłe potrzebujemy raportu kontrolnego od Twojego lekarza weterynarii, który wyjaśni stan Twojego zwierzaka i postępy leczenia. Ten raport musi być aktualizowany co 6 miesięcy.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Treatment recommendation",
              "value": "W przesłanym dokumencie widzimy zalecone przez lekarza weterynarii leczenie, ale potrzebujemy pełnego raportu z wizyty.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Signed and stamped",
              "value": "Potrzebujemy raportu podpisanego i opieczętowanego przez Twojego weterynarza.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },{"label": "Screenshots Not Accepted","value": "Otrzymaliśmy Twój wniosek o refundację, jednak nie możemy zaakceptować zrzutów ekranu ani zdjęć ekranów z dokumentami. Prosimy o poproszenie kliniki o dokumenty w formacie PDF i załączenie ich przez aplikację."}
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Certificado de alta del chip",
              "value": "Potrzebujemy, abyś wysłał certyfikat rejestracji chipa Twojego zwierzaka."
            },
            {
              "label": "Contrato de compra o adopción",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Falta",
                    "value": "Potrzebujemy, abyś wysłał umowę kupna lub adopcji Twojego zwierzaka."
                  },
                  {
                    "label": "No es legible",
                    "value": "Umowa kupna lub adopcji: dokument, który nam wysyłasz, jest nieczytelny."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Potrzebujemy Twojego numeru IBAN.",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Ultrasound",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "USG: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy oryginalnego raportu z wykonanego USG. Raport musi zawierać dane zwierzaka oraz datę wykonania badania."
                  },
                  {
                    "label": "Unreadable",
                    "value": "USG, które nam wysyłasz, jest nieczytelne."
                  }
                ]
              }
            },
            {
              "label": "Echocardiography",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Echokardiografia: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy oryginalnego raportu z wykonanej echokardiografii. Raport musi zawierać dane zwierzaka oraz datę wykonania badania."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Echokardiografia, którą nam wysyłasz, jest nieczytelna."
                  }
                ]
              }
            },
            {
              "label": "Radiography",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Prześwietlenie: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy, abyś dołączył wykonane prześwietlenia z oryginalnym znakiem wodnym lub w formacie DICOM (.dcm)."
                  },
                  {
                    "label": "Original documents",
                    "value": "Potrzebujemy oryginalnych obrazów wykonanego prześwietlenia. Mogą być w formacie DICOM (.dcm). Format ten jest dla prześwietleń tym, czym jpg dla fotografii. Chociaż Ty możesz nie być w stanie ich otworzyć, my tak."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Prześwietlenie, które nam wysyłasz, jest nieczytelne."
                  }
                ]
              }
            },
            {
              "label": "MRI",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Rezonans magnetyczny: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy oryginalnego raportu z wykonanego rezonansu magnetycznego. Raport musi zawierać dane zwierzaka oraz datę wykonania badania."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Rezonans, który nam wysyłasz, jest nieczytelny."
                  }
                ]
              }
            },
            {
              "label": "TAC",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Tomografia: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy oryginalnego raportu z wykonanej tomografii. Raport musi zawierać dane zwierzaka oraz datę wykonania badania."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Tomografia, którą nam wysyłasz, jest nieczytelna."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Analytics",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Wyniki badań: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy wyników lub oryginalnego dokumentu z wykonanych badań. Raport musi zawierać dane zwierzaka oraz datę wykonania badania.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Wyniki badań, które nam wysyłasz, są nieczytelne.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Biopsy",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Biopsja: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy wyników lub oryginalnego dokumentu z wykonanej biopsji. Raport musi zawierać dane zwierzaka oraz datę wykonania badania.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Wyniki biopsji, które nam wysyłasz, są nieczytelne.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Citology",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Cytologia: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy wyników lub oryginalnego dokumentu z wykonanej cytologii. Raport musi zawierać dane zwierzaka oraz datę wykonania badania.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Wyniki cytologii, które nam wysyłasz, są nieczytelne.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Urine test",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Badanie moczu: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy wyników lub oryginalnego dokumentu z wykonanego badania moczu. Raport musi zawierać dane zwierzaka oraz datę wykonania badania.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Wyniki badania moczu, które nam wysyłasz, są nieczytelne.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Vaccination card",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę. W sekcji notatek wskażemy, gdzie zauważyliśmy nieuzasadnioną zmianę."
                  },
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy, abyś wysłał zdjęcie książeczki lub paszportu, na którym widać dane zwierzaka oraz wszystkie szczepienia, jakie otrzymał."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Dokument, który nam wysyłasz, jest nieczytelny."
                  },
                  {
                    "label": "Chipnumber",
                    "value": "Potrzebujemy, abyś wysłał zdjęcie książeczki lub paszportu, na którym widać numer chipa zwierzaka."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    "prevention": {
      "templates": [
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Changes",
              "value": "Książeczka szczepień: potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę."
            },
            {
              "label": "Missing",
              "value": "Potrzebujemy, abyś wysłał zdjęcie książeczki lub paszportu, na którym widać to szczepienie oraz wszystkie wykonane szczepienia."
            },
            {
              "label": "Unreadable",
              "value": "Książeczka szczepień, którą nam wysyłasz, jest nieczytelna."
            },
            {
              "label": "Chipnumber",
              "value": "Potrzebujemy, abyś wysłał zdjęcie książeczki lub paszportu, na którym widać numer chipa zwierzaka."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Missing",
              "value": "Potrzebujemy historii weterynaryjnej Twojego zwierzaka od momentu, gdy mieszka z Tobą. Poproś o nią we wszystkich klinikach, w których był leczony. Musi zawierać:\n - Wszystkie wizyty u lekarza weterynarii: zarówno szczepienia, wizyty kontrolne, jak i z powodu choroby lub wypadku.\n - Datę każdej wizyty oraz obserwacje lekarza weterynarii.\n - Potwierdzenie, że jest kompletna: lekarz weterynarii powinien napisać np. „Brak innych zarejestrowanych wizyt w tej klinice”.\n - Podpisana i opieczętowana przez klinikę.\n - Jedna historia z każdej kliniki: jeśli odwiedziłeś więcej niż jedną klinikę, potrzebujemy historii z każdej z nich, nawet jeśli była to tylko wizyta na szczepienia.\n - Nie akceptujemy luźnych kartek ani niekompletnych dokumentów."
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Missing",
              "value": "Potrzebujemy oryginalnego raportu z wykonanego badania. Raport musi zawierać dane zwierzaka oraz datę wykonania badania."
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Missing",
              "value": "Potrzebujemy oryginalnego raportu z wykonanych badań. Raport musi zawierać dane zwierzaka oraz datę wykonania badania.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Chip registration certificate",
              "value": "Potrzebujemy, abyś wysłał certyfikat rejestracji chipa Twojego zwierzaka."
            },
            {
              "label": "Purchase or adoption contract",
              "value": {
                "group": "Co się dzieje?",
                "options": [
                  {
                    "label": "Missing",
                    "value": "Potrzebujemy, abyś wysłał umowę kupna lub adopcji Twojego zwierzaka."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Umowa kupna lub adopcji: dokument, który nam wysyłasz, jest nieczytelny."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Potrzebujemy Twojego numeru IBAN.",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Changes",
              "value": "Potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Complete invoice",
              "value": "Potrzebujemy pełnej faktury. Pobierz fakturę w formacie PDF i wyślij nam ten dokument w sekcji dotyczącej faktury. Nie możemy zaakceptować faktur w postaci wielu zrzutów ekranu."
            },
            {
              "label": "CIF",
              "value": "Na fakturze, którą nam wysyłasz, brakuje numeru NIP lub jest niekompletny.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Invoice number",
              "value": "Na fakturze, którą nam wysyłasz, brakuje numeru faktury lub jest niekompletny.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Receipt covers the invoice",
              "value": "Paragon zasłania fakturę lub jej część i nie możemy odczytać jej treści.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Duplicated invoice",
              "value": "Otrzymaliśmy fakturę z tej kliniki o tym samym numerze, ale dotyczącą innego zwierzaka, więc nie jest ona ważna. Faktury muszą mieć unikalny numer — nie mogą istnieć dwie faktury tego samego wystawcy i z tego samego roku o tym samym numerze. Udaj się do kliniki i poproś o wystawienie ważnej faktury.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "More than one pet",
              "value": "Faktura, którą nam wysyłasz, zawiera koszty kilku zwierząt. Prześlij osobną fakturę dla każdego ubezpieczonego zwierzaka.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Missing",
              "value": "Potrzebujemy faktury za wykonane usługi. Pamiętaj, że na fakturze musi pojawić się numer NIP kliniki, numer faktury oraz data poniesienia wydatku.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Unreadable",
              "value": "Faktura, którą nam wysyłasz, jest nieczytelna lub obcięta. Wyślij kompletną fakturę w formacie PDF.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Not an invoice",
              "value": "Dokument, który nam przesyłasz, nie jest fakturą. Nie martw się — aby ją otrzymać, wróć do lecznicy lub apteki i poproś o wystawienie faktury. Dokument musi zawierać: numer NIP kliniki, numer faktury oraz datę poniesienia wydatku. Zgodnie z warunkami polisy możemy akceptować tylko faktury. Pamiętaj, że paragony, kosztorysy, faktury proforma, faktury uproszczone lub faktury z numerem 0 nie są ważne.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "One single document",
              "value": "Prześlij nam fakturę jako jeden dokument, najlepiej w formacie PDF. W przesłanej formie nie możemy prawidłowo odczytać kolejności treści. Jeśli weterynarz przekazał Ci fakturę w wersji papierowej i musisz zrobić jej zdjęcia, upewnij się, że cała faktura jest widoczna na jednym zdjęciu.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Otrzymaliśmy Twój wniosek o zwrot kosztów, ale nie możemy zaakceptować zrzutów ekranu ani zdjęć ekranów dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF i załącz je przez aplikację."
            },
            {
              "label": "Signed and stamped",
              "value": "Potrzebujemy faktury podpisanej i opieczętowanej przez Twojego weterynarza.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline explanation",
              "value": "Poproś lekarza weterynarii, aby dołączył do raportu lub jako załącznik do faktury wyjaśnienie, jakiemu leczeniu odpowiadają następujące pozycje faktury: {{línea_de_coste;STRING;true}}. Powinno zawierać nazwę leczenia i jego cenę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Changes",
              "value": "Potrzebujemy, aby Twój lekarz weterynarii sporządził opieczętowany raport z pełnym imieniem i nazwiskiem, numerem prawa wykonywania zawodu i podpisem, wyjaśniający, dlaczego w dokumencie wprowadzono zmianę.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Czego brakuje?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Brakuje raportu weterynaryjnego z następujących klinik: {{clinica;STRING;true}}.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "All",
                    "value": "Potrzebujemy raportu weterynaryjnego. Musi to być dokument sporządzony przez lekarza weterynarii opisujący wizytę, której dotyczy wniosek o zwrot. Raport musi zawierać:\nPowód wizyty: np. „Mojego psa boli łapa.”\nZaobserwowane objawy: np. „Ból przy dotyku, kulawizna, guzek na łapie.”\nData pojawienia się objawów.\nWykonane badania: np. „Prześwietlenia, badanie kliniczne.”\nDiagnoza: np. „Uraz tylnej kończyny w wyniku stłuczenia.”\nZalecone leczenie: np. „Odpoczynek, leki.”\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  },
                  {
                    "label": "Dates",
                    "value": "Brakuje raportu weterynaryjnego z następujących dat: {{fecha;DATE_RANGE;true}}.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
                  }
                ]
              }
            },
            {
              "label": "Not a vet report",
              "value": "Dokument, który nam wysłałeś, nie jest raportem weterynaryjnym. Musi to być dokument sporządzony przez lekarza weterynarii, opisujący wizytę, której dotyczy wniosek o zwrot. Raport powinien zawierać:\n - Powód wizyty: np. „Mojego psa boli łapa.”\n - Zaobserwowane objawy: np. „Ból przy dotyku, kulawizna, guzek na łapie.”\n - Data pojawienia się objawów.\n - Wykonane badania: np. „Prześwietlenia, badanie kliniczne.”\n - Diagnoza: np. „Uraz tylnej kończyny w wyniku stłuczenia.”\n - Zalecone leczenie: np. „Odpoczynek, leki.”.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Costline breakdown",
              "value": "Poproś lekarza weterynarii, aby wskazał w raporcie lub jako załącznik do faktury każdą usługę lub zabieg wykonany u zwierzaka oraz ich cenę osobno.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Vet report doesn't match the invoice",
              "value": "Raport, który nam wysyłasz, nie odpowiada fakturze. Faktury muszą zawsze być powiązane z raportami.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Unreadable",
              "value": "Raport weterynaryjny, który nam wysyłasz, jest nieczytelny lub ucięty. Wyślij kompletny raport w formacie PDF.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
              "label": "Signed and stamped",
              "value": "Potrzebujemy raportu podpisanego i opieczętowanego przez Twojego weterynarza.\n\nNie możemy zaakceptować zrzutów ekranu ani zdjęć ekranu dokumentów. Poproś swoją klinikę o dokumenty w formacie PDF."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Otrzymaliśmy Twój wniosek o refundację, jednak nie możemy zaakceptować zrzutów ekranu ani zdjęć ekranów z dokumentami. Prosimy o poproszenie kliniki o dokumenty w formacie PDF i załączenie ich przez aplikację."
            }
          ]
        }
      ]
    }
  },
  "resolution": {
    "templates": [
      {
        "group": "Waiting period",
        "options": [
          {
            "label": "5 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Po weryfikacji dokumentacji {{petName}} informujemy, że Twoja faktura, lub jej część, nie mogła zostać zatwierdzona. Twoja polisa przewiduje okres karencji wynoszący 5 dni dla wypadków, liczony od daty zawarcia umowy. W tym przypadku wskazany stan: {{condition;STRING;true}}, pojawił się lub wymagał opieki weterynaryjnej w dniu: {{date;DATE;true}}, w ciągu tych 5 dni. Z tego powodu nie jest on objęty ubezpieczeniem i jest uznawany za istniejący wcześniej. Jeśli ten stan będzie się utrzymywał lub pojawi się ponownie w przyszłości w sposób nawracający lub przewlekły, ani ten epizod, ani ewentualne nawroty lub powikłania z niego wynikające nie będą mogły zostać zrefundowane, niezależnie od daty ostatecznej diagnozy."
          },
          {
            "label": "28 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Po przeanalizowaniu dokumentacji {{petName}} informujemy, że Twoja faktura, lub jej część, nie mogła zostać zatwierdzona. Twoja polisa przewiduje okres karencji wynoszący 28 dni dla chorób, liczony od daty zawarcia umowy. Polisa określa szczegółową listę sytuacji objętych skróconą karencją 5-dniową, a ten stan niestety nie znajduje się wśród nich, dlatego zastosowanie ma ogólna karencja 28-dniowa. W tym przypadku wskazany stan: {{condition;STRING;true}}, pojawił się lub wymagał opieki weterynaryjnej w dniu: {{date;DATE;true}}, w ciągu tych 28 dni, i jest klasyfikowany jako choroba, ponieważ nie spełnia warunków określonych w polisie, aby mógł zostać uznany za wypadek. Z tego powodu nie jest objęty ubezpieczeniem i jest uznawany za istniejący wcześniej. Jeśli ten stan będzie się utrzymywał lub pojawi się ponownie w przyszłości w sposób nawracający lub przewlekły, ani ten epizod, ani ewentualne nawroty lub powikłania z niego wynikające nie będą mogły zostać zrefundowane, niezależnie od daty ostatecznej diagnozy."
          },
          {
            "label": "6 MONTH WAITING PERIOD / PREEXISTENCE",
                        "value": "Po przeanalizowaniu dokumentacji {{petName}} informujemy, że Twoja faktura, lub jej część, nie mogła zostać zatwierdzona. Twoja polisa przewiduje okres karencji wynoszący 6 miesięcy dla określonych schorzeń, liczony od daty zawarcia umowy. Do tych schorzeń należą: dysplazja stawu biodrowego, dysplazja stawu łokciowego, zerwanie lub choroba więzadła krzyżowego, zwichnięcie rzepki, atopia, alergiczne zapalenie skóry, padaczka, zaburzenia zachowania, leiszmanioza, zaćma i przepuklina dysku. Jeśli zwierzę miało ponad 6 miesięcy w momencie zawarcia polisy, schorzenia te podlegają temu 6-miesięcznemu okresowi, nawet jeśli ich przyczyna może być związana z nieoczekiwanym zdarzeniem. W tym przypadku wskazany stan: {{condition;STRING;true}}, pojawił się lub był leczony w dniu: {{date;DATE;true}}, w ciągu tego 6-miesięcznego okresu. W związku z tym nie jest objęty ubezpieczeniem i jest uznawany za istniejący wcześniej. Ten stan pozostanie wyłączony z ochrony również w przyszłości: ponieważ pierwsze objawy lub pierwsza powiązana wizyta weterynaryjna miały miejsce w okresie karencji polisy, nie możemy zatwierdzić przyszłych wniosków o refundację związanych z tym stanem ani z jakimkolwiek objawem, urazem lub chorobą z niego wynikającą. Ten stan będzie trwale uznawany za istniejący wcześniej, nawet jeśli ostateczna diagnoza zostanie potwierdzona później."
          }
        ]
      },
      {
        "group": "Preexistence",
        "options": [
          {
            "label": "Preexistence/before contract",
                        "value": "Po przeanalizowaniu dokumentacji {{petName}} informujemy, że Twoja faktura, lub jej część, nie mogła zostać zatwierdzona.\n\nStan, który występuje u Twojego zwierzęcia: {{condition;STRING;true}}, jest uznawany za istniejący wcześniej, ponieważ pojawił się, wykazywał objawy lub był po raz pierwszy leczony w dniu: {{date;DATE;true}}, przed rozpoczęciem ochrony ubezpieczeniowej.\n\nStan istniejący wcześniej to każdy uraz lub choroba, która: wystąpiła lub wykazywała objawy kliniczne przed rozpoczęciem ochrony ubezpieczeniowej polisy, lub ma tę samą diagnozę lub te same objawy co uraz lub choroba, którą zwierzę miało już przed rozpoczęciem ochrony, lub jest spowodowana, powiązana lub wynika z urazu, choroby lub objawu klinicznego sprzed rozpoczęcia ochrony.\n\nPonadto ten stan pozostanie wyłączony z ochrony również w przyszłości. Oznacza to, że nie możemy zatwierdzić przyszłych wniosków o refundację związanych z tym stanem ani z jakimkolwiek objawem, urazem lub chorobą z niego wynikającą, nawet jeśli ostateczna diagnoza zostanie potwierdzona później."
          },
          {
            "label": "Same diagnosis in different body part",
            "value": "Pamiętaj, że zgodnie z warunkami Twojej polisy, jeśli Twój zwierzak chorował już przed rozpoczęciem ochrony lub w okresie karencji na: (przepuklinę lub protruzję dyskową, zerwanie lub chorobę więzadła krzyżowego, zwichnięcie rzepki, dysplazję łokcia lub biodra, zaćmę albo zwyrodnienie kości i stawów), nie zwracamy kosztów związanych z tą samą patologią, nawet jeśli później manifestuje się w innej części ciała.\n\nPrzykładowo dotyczy to: przepukliny lub protruzji w innym dysku międzykręgowym, zerwania lub choroby więzadła krzyżowego w innej łapie."
          },
          {
            "label": "Date outside coverage period",
            "value": "Faktura sprzed zawarcia polisy: niestety, Twój wniosek o zwrot został odrzucony, ponieważ data faktury, którą nam wysyłasz, jest wcześniejsza niż data rozpoczęcia polisy."
          },
          {
            "label": "Not an accident denial",
            "value": "Przeanalizowaliśmy Twoje zgłoszenie i zgodnie z Ogólnymi Warunkami Ubezpieczenia zdarzenie to nie może zostać uznane za Wypadek w rozumieniu ochrony ubezpieczeniowej.\n\nPolisa stanowi, że aby dane zdarzenie mogło zostać uznane za Wypadek, musi spełniać definicję wypadku określoną w umowie oraz należeć wyłącznie do jednej z następujących kategorii:\n\nZłamania lub zwichnięcia stawów spowodowane urazem.\nRozdarcia skóry, rany po ugryzieniu (z wyjątkiem ukąszeń owadów) lub otarcia skóry.\nOparzenia lub obrażenia spowodowane porażeniem prądem.\nUrazy spowodowane przez pojazd.\nZatrucia.\nRany postrzałowe lub od pocisku.\nPoważne stłuczenia lub obrażenia zmiażdżeniowe.\nUrazowe uszkodzenia zębów.\nCiała obce w przewodzie pokarmowym.\n\nPonadto Ogólne Warunki Ubezpieczenia wyraźnie wskazują, że urazy lub schorzenia, które pomimo wystąpienia zdarzenia urazowego odpowiadają patologii objętej szczególnym okresem karencji przewidzianym w umowie, podlegają temu okresowi karencji, a nie okresowi przewidzianemu dla Wypadków.\n\nZ tego względu w tym przypadku ma zastosowanie 28-dniowy okres karencji, a nie 5-dniowy okres karencji przewidziany dla Wypadków.\n\nPonieważ objawy i/lub leczenie wystąpiły w okresie karencji, niestety nie możemy zwrócić poniesionych kosztów."
          }
        ]
      },
      {
        "group": "Vaccinations are not up to date",
        "options": [
          {
            "label": "Vaccinations are not up to date",
            "value": "Roczny harmonogram szczepień nie jest aktualny. Zgodnie z ogólnymi warunkami Twojej polisy, Twój zwierzak musi mieć aktualne szczepienia przeciwko następującym chorobom: wściekliźnie, nosówce, zapaleniu wątroby i parwowirozie. W tym przypadku schemat szczepień nie jest pełny lub nie były przestrzegane zalecenia lekarza weterynarii. Nie możemy pokryć kosztów weterynaryjnych wynikających z rozwoju tej choroby."
          }
        ]
      },
      {
        "group": "Disclaimer",
        "options": [
          {
            "label": "Disclaimer Clinical history",
            "value": "Historia kliniczna. Chcę przypomnieć, że przy kolejnym wniosku o zwrot kosztów potrzebujemy, abyś przesłał historię kliniczną Twojego zwierzaka. Historia kliniczna zawiera, w jednym dokumencie, wszystkie wizyty u lekarza weterynarii, zarówno z powodu choroby lub wypadku, jak i rutynowe wizyty kontrolne czy szczepienia, wraz z datą wizyty i odpowiednimi notatkami weterynaryjnymi. Jeśli zwierzak był w więcej niż jednej klinice, należy poprosić o nią w każdej z nich. Każda strona tego dokumentu musi być ponumerowana, a na ostatniej stronie potrzebny jest podpis i pieczęć kliniki. Musisz również dołączyć zaświadczenie, że wizyty zawarte w historii to jedyne wizyty, które Twój pupil odbył w tej klinice."
          },
          {
            "label": "More than one pet",
            "value": "Aby przyspieszyć rozpatrywanie przyszłych wniosków, zalecamy, aby każda faktura dotyczyła tylko jednego zwierzaka. Faktury obejmujące wydatki kilku zwierząt mogą skutkować prośbą o dodatkowe informacje."
          },
          {
            "label": "Complementary sessions limit reacheds",
            "value": "Informujemy, że wykorzystałeś już 8 sesji/zabiegów uzupełniających przewidzianych w obowiązującym okresie Twojej umowy."
          },
          {
            "label": "Annual visit limit reached",
            "value": "Wykorzystałeś już coroczną wizytę kontrolną objętą Twoją polisą."
          },
          {
            "label": "Unjustified costlines",
            "value": "Część wskazanych kosztów nie jest wystarczająco uzasadniona w dostarczonej dokumentacji i w związku z tym nie może być oceniona zgodnie z warunkami ubezpieczenia."
          },
          {
            "label": "Outside EU, UK and Andorra",
            "value": "Twoja polisa nie obejmuje wydatków powstałych poza Unią Europejską, Wielką Brytanią i Andorą."
          },
          {
            "label": "Disclaimer chronic condition revision",
            "value": "Raport kontrolny. Przypominamy, że aby możliwe było zwracanie kosztów leków na choroby przewlekłe, konieczna jest kontrola weterynaryjna co 6 miesięcy. Prosimy o przesłanie raportu z kontroli wraz z kolejnym wnioskiem."
          },
          {
            "label": "Prostheses, implants, pacemakers and transplants",
            "value": "Zgodnie z Ogólnymi Warunkami Twojej polisy wyłączone z ochrony są przeszczepy (w tym opieka przed- i pooperacyjna), rozruszniki serca, protezy, implanty (z wyjątkiem implantów do osteosyntezy), a także sztuczne części ciała i sztuczne stawy."
          }
        ]
      },
      {
        "group": "Preventative/routinary costline",
        "options": [
          {
            "label": "Preventative/routinary costline",
            "value": "Leczenie profilaktyczne. Ubezpieczenie Barkibu pokrywa wyłącznie wydatki weterynaryjne wynikające z choroby lub wypadku. Wydatki, które nam przesyłasz, dotyczą leczenia rutynowego lub profilaktycznego i dlatego nie są objęte ochroną."
          }
        ]
      },
      {
        "group": "Postmortem",
        "options": [
          {
            "label": "Our condolences",
            "value": "Chcielibyśmy przekazać Ci, w imieniu całego zespołu Barkibu, jak największe wsparcie w tych trudnych chwilach. Bardzo nam przykro z powodu tego, co się stało."
          }
        ]
      },
      {
        "group": "Prevention outside of country",
        "options": [
          {
            "label": "Prevention outside of country",
            "value": "Twoja polisa profilaktyczna obowiązuje wyłącznie na terenie Polski."
          }
        ]
      },
      {
        "group": "Shunt/congenital malformation",
        "options": [
          {
            "label": "Shunt/congenital malformation",
            "value": "Zgodnie z warunkami ogólnymi nie są objęte ochroną wydatki związane z patologicznymi wrodzonymi zespoleniami naczyniowymi oraz wrodzonymi wadami serca (na przykład zespolenie wrotno-oboczne lub przetrwały przewód tętniczy, nawet jeśli nie były znane w momencie zawarcia polisy)."
          }
        ]
      },
      {
        "group": "Brachycephalic Syndrome",
        "options": [
          {
            "label": "Brachycephalic Syndrome",
            "value": "Zespół brachycefaliczny jest wyłączony z ochrony zgodnie z postanowieniami ogólnych warunków polisy. W związku z tym wydatki związane z jego diagnozą i leczeniem nie mogą być zwracane."
          }
        ]
      },
      {
        "group": "Annual limit reached",
        "options": [
          {
            "label": "Annual limit reached",
            "value": "Informujemy, że osiągnąłeś roczny limit Twojej polisy."
          }
        ]
      },
      {
        "group": "Prevention",
        "options": [
          {
            "label": "Vaccinations not covered",
            "value": "Szczepienie nieobjęte ochroną: pakiet opieki profilaktycznej Twojego ubezpieczenia weterynaryjnego obejmuje szczepienie przeciwko wściekliźnie, szczepienie poliwalentne i przeciwko kaszlowi kenelowemu u psów oraz szczepienie przeciwko wściekliźnie, triwalentne i przeciwko białaczce u kotów."
          },
          {
            "label": "Annual visit with tests",
            "value": "Coroczna wizyta z badaniami: pakiet opieki profilaktycznej Twojego ubezpieczenia weterynaryjnego obejmuje jedną coroczną wizytę profilaktyczną, niezwiązaną z chorobą, wypadkiem ani objawami u zwierzaka. Wizyta ta nie obejmuje badań ani analiz wykonywanych u zwierzaka. Wizyta, którą nam wysyłasz, nie spełnia tych wymogów, więc nie jest objęta ochroną."
          }
        ]
      }
    ]
  },
  "close_claim": {
    "templates": [
      {
        "group": "Zamknięcie wniosku",
        "options": [
          {
            "label": "Missing information",
            "value": "Zamknęliśmy Twój wniosek, ponieważ otrzymana dokumentacja jest niewystarczająca do jego rozpatrzenia. Wskazaliśmy w aplikacji potrzebne dokumenty, ale nie otrzymaliśmy ich poprawnie. Jeśli chcesz, abyśmy ponownie go rozpatrzyli, utwórz nowy wniosek z pełną wymaganą dokumentacją."
          },
          {
            "label": "Outstanding documents in another request",
            "value": "Zamknęliśmy ten wniosek, ponieważ jest powiązany z innym, który nadal pozostaje otwarty i oczekuje na dokumentację z Twojej strony. Wymagane dokumenty należy przesłać bezpośrednio w tym wniosku, który w aplikacji oznaczony jest jako „Brak dokumentów”."
          },
          {
            "label": "Duplicated invoice",
            "value": "Zamknęliśmy Twój wniosek, ponieważ po ponownej weryfikacji faktur stwierdziliśmy, że zostały one już uwzględnione w poprzednim wniosku."
          },
          {
            "label": "Erroneous pet",
            "value": "Zamknęliśmy Twój wniosek, ponieważ przedstawione wydatki nie dotyczą zwierzaka ubezpieczonego w ramach tej polisy."
          },
          {
            "label": "Suspended/cancelled policy",
            "value": "Zamknęliśmy Twój wniosek, ponieważ Twoja polisa jest obecnie zawieszona. Wielokrotnie próbowaliśmy się z Tobą skontaktować w celu aktualizacji płatności i pobrania zaległych składek, ale bez powodzenia. Po uregulowaniu sytuacji będziesz mógł złożyć nowy wniosek z poziomu aplikacji."
          },
          {
            "label": "Pet parent asked to close the claim",
            "value": "Zamknęliśmy Twój wniosek, ponieważ poprosiłeś nas o to."
          },
          {
            "label": "Fraud documentation from clinic",
            "value": "Ze względu na rozbieżności wykryte w poprzednich wnioskach o zwrot kosztów, od teraz cała dokumentacja dotycząca przyszłych zwrotów musi być wysyłana bezpośrednio przez Twoją klinikę weterynaryjną na adres clinic@barkibu.com.\n\nGdy Twoja klinika ją prześle, ważne jest, abyś ponownie otworzył wniosek w aplikacji z tymi samymi dokumentami, dodając notatkę: „Moja klinika już wysłała dokumentację\", abyśmy mogli ją sprawdzić.\n\nProsimy, aby ułatwić obsługę Twoich zwrotów, nigdy nie twórz wniosku z dokumentami, które nie zostały nam wcześniej przesłane przez Twoją klinikę na wskazany powyżej adres e-mail."
          },
          {
            "label": "No response from clinic",
            "value": "Zamknęliśmy Twoje zgłoszenie, ponieważ na podstawie dotychczas dostarczonej dokumentacji nie dysponujemy wystarczającymi informacjami, aby dokonać oceny. Kilkukrotnie próbowaliśmy skontaktować się z Twoją kliniką, aby uzupełnić informacje, ale bezskutecznie.\n\nAbyśmy mogli rozpatrzyć Twoje zgłoszenia, skontaktuj się ze swoją kliniką, aby sprawdziła swoją skrzynkę e-mail.\n\nGdy tylko nam odpowie, będziesz mógł ponownie otworzyć zgłoszenie w aplikacji."
          },
          {
            "label": "Fraud",
            "value": "Po przeanalizowaniu przesłanej dokumentacji wykryliśmy niezgodności, które uniemożliwiają nam zatwierdzenie Twojego wniosku.\n\nOd teraz cała dokumentacja dotycząca przyszłych zwrotów musi być wysyłana bezpośrednio przez Twoją klinikę weterynaryjną na adres clinic@barkibu.com.\n\nGdy Twoja klinika ją prześle, ważne jest, abyś ponownie otworzył wniosek w aplikacji z tymi samymi dokumentami, dodając notatkę: „Moja klinika już przesłała dokumentację\", abyśmy mogli go rozpatrzyć.\n\nProsimy, aby ułatwić obsługę Twoich zwrotów, nigdy nie twórz wniosku z dokumentami, które nie zostały nam wcześniej przesłane przez Twoją klinikę na wskazany powyżej adres e-mail."
          }
        ]
      }
    ]
  }
}
